import { useEffect, useState } from "react";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import { db } from "../config/firebase";

const SECTIONS = [
  { id: "pavilionEvents",   label: "PB Pavilion",       nameField: "title" },
];

export default function AdminAvailability() {
  const [section, setSection] = useState("villas");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toggling, setToggling] = useState(null);

  useEffect(() => {
    const fetchItems = async () => {
      setLoading(true);
      try {
        const snap = await getDocs(collection(db, section));
        const data = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        data.sort((a, b) => a.id.localeCompare(b.id));
        setItems(data);
      } catch (err) {
        console.error("AdminAvailability fetch error:", err);
        setItems([]);
      } finally {
        setLoading(false);
      }
    };
    fetchItems();
  }, [section]);

  const handleToggle = async (item) => {
    const newAvailable = item.available === false;
    setToggling(item.id);
    try {
      await updateDoc(doc(db, section, item.id), { available: newAvailable });
      setItems((prev) =>
        prev.map((i) => (i.id === item.id ? { ...i, available: newAvailable } : i))
      );
    } catch (err) {
      console.error("AdminAvailability toggle error:", err);
    } finally {
      setToggling(null);
    }
  };

  const currentSection = SECTIONS.find((s) => s.id === section);
  const available = items.filter((i) => i.available !== false).length;
  const total = items.length;

  return (
    <div>
      <div className="admin-filter-row">
        {SECTIONS.map((s) => (
          <button
            key={s.id}
            className={`filter-btn ${section === s.id ? "active" : ""}`}
            onClick={() => setSection(s.id)}
          >
            {s.label}
          </button>
        ))}
        {!loading && (
          <span className="booking-count">{available} / {total} available</span>
        )}
      </div>

      {loading ? (
        <p className="admin-loading">Loading...</p>
      ) : items.length === 0 ? (
        <div className="admin-empty">No items found in this section.</div>
      ) : (
        <div className="availability-grid">
          {items.map((item) => {
            const isAvailable = item.available !== false;
            const name = item[currentSection.nameField] || item.name || item.title || item.id;
            const isBusy = toggling === item.id;
            return (
              <div
                key={item.id}
                className={`availability-card ${isAvailable ? "avail-on" : "avail-off"}`}
              >
                <span className="avail-name">{name}</span>
                <div className="avail-toggle-row">
                  <span className={`avail-status ${isAvailable ? "status-available" : "status-unavailable"}`}>
                    {isAvailable ? "Available" : "Unavailable"}
                  </span>
                  <button
                    className={`avail-toggle ${isAvailable ? "toggle-on" : "toggle-off"} ${isBusy ? "toggle-busy" : ""}`}
                    onClick={() => handleToggle(item)}
                    disabled={isBusy}
                    aria-label={`Mark ${name} as ${isAvailable ? "unavailable" : "available"}`}
                  >
                    <span className="toggle-knob" />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
